import React from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { DataMergeType, IMergeConflictViewModel } from "services/api/types";
import { MyLocalDataTable } from "components/DataTables/MyLocalDataTable";
import { Column, Action } from "components/DataTables/MyGenericTableTypes";
import Button from "@mui/material/Button";

type Props = {
  mergeConflicts: IMergeConflictViewModel[];
  useDiscardedValue: (mergeActionId: string) => Promise<void>;
  dataMergeType: DataMergeType;
};

const MergeConflictsTable = (props: Props) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {},
      wrap: {
        whiteSpace: "pre-wrap",
      },
    })
  );

  const classes = useStyles();

  const handleUseDiscardedValueClick = async (
    mergeActionId: string,
    kept: string,
    discarded: string
  ) => {
    const msg = `Are you sure you want to use\r\n\r\n${discarded}\r\n\r\ninstead of\r\n\r\n${kept}`;
    if (window.confirm(msg)) {
      await props.useDiscardedValue(mergeActionId);
    }
  };

  const columns: Column<IMergeConflictViewModel>[] = [
    {
      propertyName: "fieldName",
      label: "Field Name",
    },
    {
      propertyName: "currentValue",
      label: "Current Value",
      render: (row) => <div className={classes.wrap}>{row.currentValue}</div>,
    },
    {
      propertyName: "valueForDeleted",
      label: "Discarded Value",
      render: (row) => (
        <div className={classes.wrap}>{row.valueForDeleted}</div>
      ),
    },
    {
      label: "",
      render: (row) => (
        <div>
          <Button
            size="small"
            variant="contained"
            onClick={() =>
              handleUseDiscardedValueClick(
                row.mergeActionId,
                row.currentValue,
                row.valueForDeleted
              )
            }
          >
            Use discarded value
          </Button>
        </div>
      ),
    },
  ];
  const actions: Action<IMergeConflictViewModel>[] = [];

  return (
    <div className={classes.root}>
      <MyLocalDataTable
        actions={actions}
        noDataMessage="No conflicts found"
        columns={columns}
        showMenu={false}
        hideBottomAppBar={true}
        hideFilter={true}
        defaultSortColumn="contactLastName"
        defaultSortOrder="asc"
        hideToolbar={true}
        data={props.mergeConflicts}
      />
    </div>
  );
};

export { MergeConflictsTable };
